export default __webpack_public_path__ + "35a090298acf10743d65e9f123553597.png";